import React, {Fragment, useEffect, useState} from 'react'
import {Table, Card, Button, Input, message, Popconfirm, Upload, Popover} from 'antd'
import {getParmUrl} from '@/public/utils'
import {Link} from 'react-router-dom'
import {getQrcodeList, updateQrCode, addQrCode, deleteQrCode} from './service'
import AddQrcodeModal from './AddQrcodeModal'
import ResourcePreviewContent from '../../compenents/ResourcePreviewContent'
import get from 'lodash/get'
import styles from './editbrandwx.module.less'

const EditBrandWx = props => {
  const {match: {params}} = props

  const brandId = params.id || undefined

  const [visible, setVisible] = useState(false)

  const [qrData, setData] = useState({
    list: [],
    total: 0,
    page_size: 10, 
    page_index: 1,
  })

  const [qrParams, setQrParams] = useState({
    page_index: 1,
    page_size: 10,
    brand_id: brandId,
    qy_user_id: ''
  })

  const [editQrcodeObj, setEditQrcodeObj] = useState(null)

  const [brandName, setBrandName] = useState('')

  useEffect(() => {
    if (getParmUrl('brandname')) {
      setBrandName(getParmUrl('brandname'))
    }
    getQrcodeListFn()
  }, [qrParams])

  const getQrcodeListFn = async () => {
    const res = await getQrcodeList({
      ...qrParams, 
      brand_id: brandId
    })

    if (res) {
      const list = (res.data || []).map(r => {
        return {
          ...r,
          qr_code_pic: [
            {
              uid: '-1',
              url: r.qr_code_pic
            }
          ]
        }
      })
      setData({...res, data: list})
    }
  }

  const handleSearch = (value) => {
    setQrParams({...qrParams, page_index: 1, qy_user_id: value})
  }


  const pageChange = ({current, pageSize}) => {
    setQrParams({...qrParams, page_index: current})
  }

  const handleChangeVisible = () => {
    setVisible(!visible)
  }

  const onClose = () => {

    setEditQrcodeObj(null)

    handleChangeVisible()
  }

  const editQrCode = (obj) => {

    setEditQrcodeObj({...obj})

    handleChangeVisible()
  }

  const sumbit = async (values) => {
    const action = editQrcodeObj ? updateQrCode : addQrCode

    const res = await action({
      ...values
    })
    if (res && res.result) {
      message.success(`${editQrcodeObj ? '编辑' : '添加'}成功`)
      setQrParams({
        ...qrParams,
        qy_user_id: '',
        page_index: values.id ? qrParams.page_index : 1
      })
      handleChangeVisible()
    }
  }

  const deleteQr = async (id) => {
    const res = await deleteQrCode({id})

    if (res) {
      message.success('删除成功')
      setQrParams({
        ...params,
        qy_user_id: '',
        page_index: 1
      })
    }
  }

  const getPositionImageRatio = record => {
    if (record && record.pic_width && record.pic_height) {
      return record.pic_width / record.pic_height
    } else {
      return 1
    }
  }

  const qrListColumns = [
    {
      title: '企微账号',
      dataIndex: 'qy_user_id'
    },
    {
      title: '企微昵称',
      dataIndex: 'qy_nick'
    },
    {
      title: '企微活码',
      dataIndex: 'qr_code_pic',
      render: (text) => {
        return (
          <Popover 
            content={
              <ResourcePreviewContent
                type='pic'
                imageRatio={getPositionImageRatio(get(text, '[0]'))}
                picUrl={get(text, '[0].url', '')}
                targetUrl={get(text, '[0].url', '')}
              />
            }
          >
            <div className={styles.uploadqr}>
              <Upload showUploadList={{showRemoveIcon: false}} listType="picture-card" fileList={text}/>
            </div>
          </Popover>
          
        )
      }
    },
    {
      title: '操作',
      dataIndex: 'operation',
      width: 180,
      render: (text, record) => {
        return (
          <Fragment>
            <a onClick={() => {editQrCode(record)}}>编辑</a>
            <Popconfirm title="确认删除?" okText="是" cancelText="否" onConfirm={() => deleteQr(record.id)}>
              <span className={styles.delete_icon}>删除</span>
            </Popconfirm>

          </Fragment>
        )
      }
    },
  ]

  return (
    <Card extra={<Link to='/main/brandwx/list'>返回</Link>}  title={`编辑${brandName}`}>
      <div className={`${styles.toolbar}`}>
        <Button type='primary' onClick={handleChangeVisible}>添加企微活码</Button>
        <div>
          <Input.Search
            placeholder="输入企微账号或昵称"
            onSearch={v => handleSearch(v)}
            onReset={() => handleSearch()}
            onPressEnter={e => {
              e.preventDefault()
              handleSearch(e.target.value)
            }}
          />
        </div>

      </div>
      <Table
        size="middle"
        rowKey="id"
        columns={qrListColumns}
        dataSource={qrData.data}
        bordered={false}
        onChange={pageChange}
        pagination={{
          total: qrData.total,
          pageSize: qrData.page_size,
          current: qrData.page_index,
          showTotal: (total, range) => `共${total}条记录，当前${range[0]}~${range[1]}条`
        }}
      />
      {visible && (
        <AddQrcodeModal 
          brandId={brandId} 
          onClose={onClose} 
          visible={visible}
          editQrcodeObj={editQrcodeObj}
          sumbit={sumbit}
        />
      )}
    </Card>
  )
}

export default EditBrandWx


// WEBPACK FOOTER //
// ./src/pages/brandwx/editbrandwx.js